import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../components/layout';
import { FacultyForm } from '../components/faculty';
import { useFaculty } from '../hooks/useFaculty';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { parseApiError } from '../lib/apiErrors';

export default function CreateFacultyPage() {
  const navigate = useNavigate();
  const { createFaculty, loading } = useFaculty();

  const handleSubmit = async (data) => {
    try {
      const faculty = await createFaculty(data);
      toast.success('Faculty created successfully!');
      navigate(`/faculty/${faculty.id}`);
    } catch (err) {
      toast.error(parseApiError(err, 'Failed to create faculty').message);
    }
  };

  return (
    <DashboardLayout title="Add Faculty">
      <div className="animate-fade-in max-w-3xl">
        <button
          onClick={() => navigate('/faculty/members')}
          className="inline-flex items-center gap-2 text-slate-600 dark:text-slate-400 hover:text-primary dark:hover:text-accent-cool mb-6 transition-colors"
          data-testid="back-btn"
        >
          <ArrowLeft size={18} />
          Back to Faculty List
        </button>

        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-6 md:p-8">
          <div className="mb-6">
            <h2 className="text-xl font-heading font-semibold text-slate-900 dark:text-white">
              Create New Faculty
            </h2>
            <p className="text-slate-500 dark:text-slate-400 mt-1">
              Fill in the details to add a new faculty member
            </p>
          </div>

          <FacultyForm 
            onSubmit={handleSubmit} 
            loading={loading}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
